import { Component, OnInit } from '@angular/core';
import { AuthService } from "../core/services/auth.service";
import { HeaderService } from "../core/services/header.service";
import { Router } from '@angular/router';
import { NgIf } from "@angular/common";

@Component({
    selector: 'app-sso',
    templateUrl: './sso.component.html',
    imports: [NgIf],
    standalone: true
})
export class SsoComponent implements OnInit {
    status: 'waiting' | 'validating' | 'success' | 'error' = 'waiting';
    errorMessage: string | null = null;

    constructor(
        private authService: AuthService,
        private headerService: HeaderService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        if (typeof window !== 'undefined') {
            // Handle token via postMessage from mobile app
            window.addEventListener('message', this.handleMessage.bind(this));

            // Manual browser testing via query string
            const params = new URLSearchParams(window.location.search);
            const idToken = params.get('idToken');
            const accessToken = params.get('accessToken');
            const refreshToken = params.get('refreshToken'); // optional for testing
            const selectedCountry = params.get('selectedCountry');

            if (idToken && accessToken) {
                console.log('[SSO] Testing mode: received tokens via query params');
                this.handleToken(idToken, accessToken, refreshToken || undefined, selectedCountry || 'us');
            }
        }
    }

    private handleMessage(event: MessageEvent): void {
        const { idToken, accessToken, refreshToken } = event?.data || {};

        if (!idToken || !accessToken) {
            this.status = 'error';
            this.errorMessage = 'Missing idToken or accessToken';
            return;
        }

        this.handleToken(idToken, accessToken, refreshToken);
    }

    private handleToken(idToken: string, accessToken: string, refreshToken?: string, selectedCountry: string = 'us'): void {
        this.status = 'validating';

        this.authService.loginWithIdToken(idToken, accessToken, refreshToken).subscribe({
            next: (response) => {
                if (response.success) {
                    this.status = 'success';

                    localStorage.setItem("user", response.user.email);

                    if (response.tokens) {
                        const tokenObject = {
                            authorization: idToken,
                            accessToken: response.tokens.authorization,
                            refreshToken: response.tokens.refresh_token
                        };
                        localStorage.setItem("tokens", JSON.stringify(tokenObject));
                    }

                    // Restore or set country
                    this.headerService.setSelectedCountry(selectedCountry).subscribe();

                    this.headerService.setAuthentication(true);
                    this.router.navigate(['/home']);
                } else {
                    this.status = 'error';
                    this.errorMessage = 'Authentication failed';
                }
            },
            error: (err) => {
                this.status = 'error';
                this.errorMessage = 'Server error during authentication';
                console.error(err);
            }
        });
    }
}